import { IonList, IonModal, IonInfiniteScroll, IonInfiniteScrollContent,IonItem, IonThumbnail, IonIcon, IonButton, IonSearchbar, IonCheckbox, IonLabel, IonApp, IonListHeader, IonContent, useIonAlert, useIonLoading, IonPage, IonLoading, useIonViewDidEnter, useIonModal, IonCard, IonCardContent, IonHeader, IonToolbar,IonTitle, IonRow, IonCol, IonGrid } from "@ionic/react"
import { useEffect, useRef, useState, useCallback, useMemo } from "react"
import { useAppDispatch, useAppSelector } from "../../../services/redux/hook"
import { Asset, CollectionParams, CustodialOperationTypes, DisplayableOperation } from "../../../types/types"

import CreateClaimableBalanceListItem from "../CreateClaimableBalanceOperationItem"
import PaymentListItem from "../PaymentOperationItem"
import TradingListItem from "../TradeOperationItem";
import TradeDetailsPage from "../../../pages/trade-details/TradeDetailsPage";
import PaymentDetailsPage from "../../../pages/payment-details/PaymentDetailsPage";
import ClaimableBalanceDetailsPage from '../../../pages/claimable-balance-details/ClaimableBalanceDetailsPage';

import { ebioroApi, useGetPaymentsQuery } from "../../../services/api/ebioro/ebioro";
import * as stellarHorizonApi from '../../../services/stellar/horizon/data/data';
import { setOperationHistoryList } from '../../../services/redux/slices/operation-history-list/operationHistoryList';
import { filterOutline, reloadOutline } from "ionicons/icons";
import './OperationList.css';
import { useTranslation } from 'react-i18next';
import * as Sentry from "@sentry/react";
import CustodialOperation from "../../CustodialOperationDetail/CustodialOperation"
import RefundDetailsPage from "../../../pages/refund-details/RefundDetailsPage"
import CashoutStatus from "../../../pages/cashout/CashoutStatus"
import CashoutListItem from "../CashoutOperationItem";
import { Keyboard } from '@capacitor/keyboard';
import { Capacitor } from "@capacitor/core"
import useCryptoMode from "../../../hooks/useCryptoMode"
import { useAccountDetailsQuery } from "../../../services/api/stellar"

interface OperationListFilter {
    filterAsset?: Asset;
    hideSearhBar?: boolean;
    hideButtonFilter?: boolean;
    marginForTransactionList?: number;
    presentingElement?: HTMLElement | null;
}



const OperationList: React.FC<OperationListFilter> = ({ filterAsset, hideSearhBar, hideButtonFilter, marginForTransactionList, presentingElement }) => {

    const dispatch = useAppDispatch();
    const { cryptoMode } = useCryptoMode();

    const modal = useRef<HTMLIonModalElement>(null);
    const { t, i18n } = useTranslation();
    const walletInfo = useAppSelector((state) => state.walletInfo);
    const storeSelectedAsset = useAppSelector((state) => state.selectedAsset);
    const [selectedOperation, setSelectedOperation] = useState<any>();
    const [showTradeDetailsPage, setShowTradeDetailsPage] = useState(false);
    const [showPaymentDetail, setShowPaymentDetail] = useState(false);
    const [showCustodialOperation, setShowCustodialOperation] = useState(false);
    const [showRefundOperation, setShowRefundOperation] = useState(false);
    const [showCashoutOperation, setShowCashoutOperation] = useState(false);
    const [selectedClaimablePayment, setSelectedClaimablePayment] = useState<any>();
    const [showClaimableDetail, setshowClaimableDetail] = useState(false);
    const [isInfiniteDisabled, setInfiniteDisabled] = useState(false);
    const [isLoadingMore, setIsLoadingMore] = useState(false);

    const [open, setOpen] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [selectedFilter, setSelectedFilter] = useState<any[]>([]);
    let updateItems: any[] = [];

    const [alltransactionHistory, setalltransactionHistory] = useState<DisplayableOperation[]>([]);
    const [displayAbleOperations, setdisplayAbleOperations] = useState<DisplayableOperation[]>([]);
    const supportedAssets = useAppSelector((state) => state.supportedAssets.supportedAssets);
    const [showLoading, setShowLoading] = useState(false);

    const { data: accountDetails } = useAccountDetailsQuery(walletInfo.account_key);
    const [operationLimit] = useState(20);
    const { data: payments,refetch: refetchPayments } = useGetPaymentsQuery({ limit: operationLimit, cursor: 'now' })


    const [present] = useIonAlert();

    const presentErrorAlert = useCallback((error: any) => {
        present({
            header: 'Error',
            message: `${error.data}`,
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    handler: () => {
                        return
                    }
                }
            ],
        })
    }, [present]);

    // Fix typo: seletedAsset -> selectedAsset
    const [selectedAsset, setSelectedAsset] = useState<Asset>(storeSelectedAsset);

    // Memoize filtered supported assets for better performance
    const filteredSupportedAssets = useMemo(() => 
        supportedAssets.filter((asset: Asset) => 
            asset.type === 'fiat' || (cryptoMode && asset.type === 'crypto')
        ), [supportedAssets, cryptoMode]
    );

    // Helper function to find asset by operation
    const findAssetByOperation = useCallback((operation: DisplayableOperation) => {
        return supportedAssets.filter((element: Asset) => 
            (operation.token?.code === element.code) || 
            (operation.sourceToken?.code === element.code)
        );
    }, [supportedAssets]);

    // Memoize filtered and sorted operations for better performance
    const filteredAndSortedOperations = useMemo(() => {
        return displayAbleOperations
            .filter((assetOperation) => {
                if (searchText === "") {
                    return true;
                }
                return (
                    assetOperation.token.code.toLowerCase().includes(searchText.toLowerCase()) ||
                    assetOperation.name?.toLowerCase().includes(searchText.toLowerCase()) ||
                    assetOperation.amount.toString().includes(searchText.toLowerCase())
                );
            })
            .sort((a, b) => b.timestamp - a.timestamp);
    }, [displayAbleOperations, searchText]);



    const goToTradeDetails = useCallback((operation: DisplayableOperation) => {
        const asset = findAssetByOperation(operation);
        setSelectedOperation(operation);
        setSelectedAsset(asset[0]);
        setShowTradeDetailsPage(true);
    }, [findAssetByOperation]);

    const closeTradeDetailsPage = useCallback(() => {
        setShowTradeDetailsPage(false);
    }, []);

    const goToPaymentDetails = useCallback((operation: DisplayableOperation) => {
        const asset = findAssetByOperation(operation);
        setSelectedAsset(asset[0]);
        setSelectedOperation(operation);

        if (operation.info && (Object.values(CustodialOperationTypes).includes(operation.kind as CustodialOperationTypes))) {
            setShowCustodialOperation(true);
            return;
        }

        if (operation.info && operation.kind === 'refund') {
            setShowRefundOperation(true);
            return;
        } else {
            setShowPaymentDetail(true);
            return;
        }
    }, [findAssetByOperation]);

    const goToClaimableDetails = useCallback((operation: DisplayableOperation) => {
        const asset = findAssetByOperation(operation);
        setSelectedAsset(asset[0]);
        setSelectedClaimablePayment(operation);
        setshowClaimableDetail(true);
    }, [findAssetByOperation]);

    const goCashoutDetails = useCallback((operation: any) => {
        const asset = findAssetByOperation(operation);
        setSelectedAsset(asset[0]);
        setSelectedOperation(operation);
        setShowCashoutOperation(true);
    }, [findAssetByOperation]);

    const filterAssetFn = useCallback(async (response: DisplayableOperation[]) => {
        let operationsToAdd: DisplayableOperation[] = [];

        dispatch(setOperationHistoryList(displayAbleOperations));

        let filteredOperations = response.filter((operation: any) => {
            const asset = filterAsset
                ? [filterAsset]
                : filteredSupportedAssets.filter((element: Asset) => {
                    return (operation.token?.code === element.code) || (operation.sourceToken?.code === element.code)
                });

            // there might be operations that contain assets that wallet does not support (i.e. other stellar accounts sending airdrops randomly to wallet via claimable balances)
            // because of this the asset length might be empty and we need to skip it
            if (asset.length) {
                if (operation.type === "liquidity_pool_deposit") {
                    return (operation.reserves_deposited.find((element: any) => element.asset.split(':')[0] === asset[0].code))
                }

                if (operation.type === "liquidity_pool_withdraw") {
                    return (operation.reserves_received.find((element: any) => element.asset.split(':')[0] === asset[0].code))
                } else {
                    return (operation.token?.code === asset[0].code) || (operation.sourceToken?.code === asset[0].code)
                }
            }
        });

        let finalOperations: DisplayableOperation[] = []

        for (let i = 0; i < filteredOperations.length; i++) {
            if (filteredOperations[i].type === 'create_claimable_balance') {
                const claimable_balance_id = filteredOperations[i].claimable_balance_id;

                if (claimable_balance_id) {
                    const [error, response] = await stellarHorizonApi.isClaimaBalance(claimable_balance_id);

                    if (error) {
                        continue
                    }

                    if (!response) {
                        continue
                    }
                }
            }

            finalOperations.push(filteredOperations[i])
        }

        operationsToAdd = [...operationsToAdd, ...finalOperations];
        return operationsToAdd;
    }, [filterAsset, filteredSupportedAssets, dispatch]);

    /** Here we are using getPayments instead because the Stellar Network gets flooded with claimable balances and where therefore (at least now)
     *  cannot use the get operations endpoint.
     */
    const loadOperations = async () => {
        try {
            // Check if the payments data is available
            if (payments && payments.length > 0) {
                // Initialize an array to store the transactions
                let transactions: DisplayableOperation[] = [];

                // Filter and process the payments based on the assets and mode (crypto/fiat)
                let receivedData = await filterAssetFn(payments);

                // Add the filtered transactions to the transactions array
                transactions = [...receivedData];

                // If we haven't fetched enough transactions yet, continue loading more
                while (transactions.length < operationLimit && payments.length) {
                    // Fetch more payments using the last transaction's ID as the cursor
                    const params: CollectionParams = {
                        cursor: payments[payments.length - 1].id,  // last payment's ID as the cursor
                        limit: 20,  // Fetch 20 more payments
                    };

                    // Dispatch the getPayments query again with the new parameters
                    const morePayments = await dispatch(ebioroApi.endpoints.getPayments.initiate(params, { forceRefetch: true })).unwrap();

                    // If no more payments are returned, break the loop
                    if (!morePayments.length) {
                        break;
                    }

                    // Filter the newly fetched payments and add them to the transactions array
                    receivedData = await filterAssetFn(morePayments);
                    transactions = [...transactions, ...receivedData];
                }

                // Update the state with the newly fetched and processed transactions
                setalltransactionHistory(transactions);
                setdisplayAbleOperations(transactions);

                // Enable the infinite scroll if more transactions can be loaded
                setInfiniteDisabled(false);
            } else {
            }
        } catch (error) {
            // Capture and report errors to Sentry
            Sentry.captureException(error);

            // Display an error alert in case of failure
            presentErrorAlert({ data: t('application.uncaught.ERROR') });

            // Ensure loading spinner is turned off in case of an error
            setShowLoading(false);
        }
    };

    useEffect(() => {

        const init = async () => {
            setShowLoading(true);
            setInfiniteDisabled(false); // Reset infinite scroll when filters change

            if (payments && payments.length > 0) {
                await loadOperations();
            }

            setShowLoading(false);
        }

        init();
    }, [filterAsset, cryptoMode, payments])

    const loadMoreEvent = async ($event: CustomEvent<void>) => {

        // Prevent multiple simultaneous calls
        if (isLoadingMore || isInfiniteDisabled) {
            ($event.target as HTMLIonInfiniteScrollElement).complete();
            return;
        }

        if (alltransactionHistory.length === 0) {
            ($event.target as HTMLIonInfiniteScrollElement).complete();
            return;
        }

        setIsLoadingMore(true);

        const limit = 20;
        let params: CollectionParams = {
            cursor: alltransactionHistory[alltransactionHistory.length - 1].id,
            limit: limit,
        }

        try {

            const response = await dispatch(ebioroApi.endpoints.getOperations.initiate(params, { forceRefetch: true })).unwrap();

            // No more data available
            if (!response || response.length === 0) {
                setInfiniteDisabled(true);
                ($event.target as HTMLIonInfiniteScrollElement).complete();
                return;
            }

            // Less data than requested means we've reached the end
            if (response.length < limit) {
                setInfiniteDisabled(true);
            }

            const receivedData = await filterAssetFn(response);
            const array = [...alltransactionHistory, ...receivedData];

            setdisplayAbleOperations(array);
            setalltransactionHistory(array);

            ($event.target as HTMLIonInfiniteScrollElement).complete();

        } catch (error) {
            Sentry.captureException(error);
            presentErrorAlert({ data: t('application.uncaught.ERROR') });
            ($event.target as HTMLIonInfiniteScrollElement).complete();

        } finally {
            setIsLoadingMore(false);
        }
    }

    const doRefresh = useCallback(async () => {
        setSelectedFilter([]);
        setShowLoading(true);
        setInfiniteDisabled(false); // Re-enable infinite scroll on refresh
        await refetchPayments();
        setShowLoading(false);
    }, [refetchPayments]);

    const closeModal = useCallback(() => {
        setOpen(false);
    }, []);

    const filterItem = useCallback((checked: boolean, val: any) => {
        let tempArr: DisplayableOperation[] = [];

        if (checked) {
            let selectedFilterVar: any[] = [];
            if (!selectedFilter.includes(val)) {
                selectedFilterVar = [...selectedFilter, val]
                setSelectedFilter(selectedFilterVar)
            } else {
                selectedFilterVar = [...selectedFilter]
            }
            selectedFilterVar.forEach((item) => {
                updateItems = alltransactionHistory.filter((transaction) => {
                    return transaction.token.code == item;
                });
                tempArr = [...tempArr, ...updateItems]
                setdisplayAbleOperations(tempArr);
            })
        } else {
            setdisplayAbleOperations([]);

            const index = selectedFilter.indexOf(val);
            if (index > -1) { // only splice array when item is found
                selectedFilter.splice(index, 1); // 2nd parameter means remove one item only
            }

            selectedFilter.forEach((item) => {
                updateItems = alltransactionHistory.filter((transaction) => {
                    return transaction.token.code == item;
                });

                tempArr = [...tempArr, ...updateItems]
                setdisplayAbleOperations(tempArr);
            })

            if (selectedFilter.length == 0) {
                return setdisplayAbleOperations(alltransactionHistory);
            }
        }
    }, [selectedFilter, alltransactionHistory]);

    const handleScrollStart = useCallback(async () => {
        if (Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android') {
            Keyboard.hide();
        }
    }, []);


    return (
        < >

            {
                hideSearhBar ? "" :
                    <IonSearchbar value={searchText}
                        className='ion-text-start search-bar-global'
                        onIonInput={(e: any) => setSearchText(e.detail.value!)}
                        animated={true}
                        placeholder={t('operation.list.component.SEARCH-LABEL') as string}
                        debounce={1000}
                    >

                    </IonSearchbar>
            }

            {
                hideButtonFilter ? "" :
                    <IonGrid>
                        <IonRow>
                            <IonCol className="ion-text-start">
                                <IonButton onClick={() => setOpen(true)} color={'primary'} size="small" fill="clear"  >
                                    <IonIcon slot="start" icon={filterOutline} />
                                    {t('operation.list.component.FILTER-LABEL')}
                                </IonButton>

                            </IonCol>

                            <IonCol className="ion-text-end">
                                <IonButton onClick={() => doRefresh()} color={'primary'} size="small" fill="clear" >
                                    <IonIcon slot="start" icon={reloadOutline} />
                                    {t('operation.list.component.REFRESH-LABEL')}
                                </IonButton>

                            </IonCol>
                        </IonRow>
                    </IonGrid>

            }
            <IonContent
                forceOverscroll={true}
                scrollEvents={true}
                onIonScrollStart={handleScrollStart}

            >

                <IonLoading isOpen={showLoading} />

                <IonModal
                    isOpen={open}
                    onDidDismiss={closeModal}
                    breakpoints={[0, 0.2, 0.5, 1]}
                    initialBreakpoint={0.5}
                    backdropBreakpoint={0.2} >
                    <IonContent fullscreen>
                        <IonHeader className="ion-no-border">
                            <IonToolbar>

                                <IonTitle>{t('operation.list.component.CODE-HEADER-LABEL')}</IonTitle>

                            </IonToolbar>
                        </IonHeader>
                        <IonCard>
                            <IonCardContent>
                                <IonList className="bg-transparent">
                                    {
                                        filteredSupportedAssets
                                            .map((asset: Asset, index: any) => {

                                                // Only include assets that have a balance in the account
                                                if (accountDetails?.details.balances[asset.identifier]) {

                                                    return (
                                                        <IonItem lines="none" key={index}>

                                                            <IonCheckbox color="primary" slot="start" checked={selectedFilter.includes(asset.display_code)}

                                                                onIonChange={(e: any) => {

                                                                    filterItem(e.detail.checked, asset.display_code)
                                                                }
                                                                }></IonCheckbox>

                                                            <IonThumbnail className="accountsPage_Thumbnail_Flag" slot="start">
                                                                <img src={asset.icon} />
                                                            </IonThumbnail>
                                                            <IonLabel className="checboxLable">{asset.display_code}</IonLabel>
                                                        </IonItem>

                                                    )

                                                }


                                            })
                                    }


                                </IonList>
                            </IonCardContent>
                        </IonCard>

                    </IonContent>
                    {/* <IonApp> */}
                </IonModal>

                <IonModal
                    isOpen={showTradeDetailsPage}
                    ref={modal}
                    presentingElement={presentingElement!}
                >

                    <TradeDetailsPage
                        closeAction={() => { closeTradeDetailsPage() }}
                        operation={selectedOperation}
                        asset={selectedAsset}
                    />

                </IonModal>

                <IonModal
                    isOpen={showPaymentDetail}
                    ref={modal}
                    presentingElement={presentingElement!}
                >
                    <PaymentDetailsPage closeAction={() => { setShowPaymentDetail(false) }} operation={selectedOperation} asset={selectedAsset} />

                </IonModal>

                <IonModal
                    isOpen={showCustodialOperation}
                    ref={modal}
                    presentingElement={presentingElement!}
                >
                    <CustodialOperation closeAction={() => { setShowCustodialOperation(false) }} operation={selectedOperation} asset={selectedAsset} />

                </IonModal>

                <IonModal
                    isOpen={showRefundOperation}
                    ref={modal}
                    presentingElement={presentingElement!}
                >
                    <RefundDetailsPage
                        closeAction={() => { setShowRefundOperation(false) }}
                        operation={selectedOperation} asset={selectedAsset}
                    />

                </IonModal>

                <IonModal
                    isOpen={showClaimableDetail}
                    ref={modal}
                    presentingElement={presentingElement!}
                >

                    <ClaimableBalanceDetailsPage
                        closeAction={() => { setshowClaimableDetail(false) }}
                        operation={selectedClaimablePayment}
                        asset={selectedAsset}
                    />

                </IonModal>

                <IonModal
                    isOpen={showCashoutOperation}
                    ref={modal}
                    presentingElement={presentingElement!}
                >
                    <CashoutStatus
                        closeAction={() => { setShowCashoutOperation(false) }}
                        operation={selectedOperation}
                    >
                    </CashoutStatus>
                </IonModal>

                <div className="ListMargin" style={{ marginBottom: `${marginForTransactionList}%` }}>

                        {
                            filteredAndSortedOperations
                                .map((assetOperation) => {

                                    const asset = findAssetByOperation(assetOperation);


                                    /** When sending path payment to itself (used when trading at market price) */
                                    if (assetOperation.type === 'path_payment_strict_send' && assetOperation.otherAccount.publicKey === walletInfo?.account_key) {

                                        return (

                                            <TradingListItem
                                                key={assetOperation.id}
                                                operation={assetOperation}
                                                asset={asset}
                                                onClick={() => { goToTradeDetails(assetOperation) }}
                                                filterAsset={filterAsset ? filterAsset : undefined}
                                            />
                                        )

                                    }

                                    if (assetOperation.type === 'claim_claimable_balance') {

                                        return (
                                            <PaymentListItem
                                                key={assetOperation.id}
                                                operation={assetOperation}
                                                asset={asset[0]}
                                                onClick={() => { goToPaymentDetails(assetOperation) }}

                                            />
                                        )

                                    }

                                    if (assetOperation.type === 'payment' || assetOperation.type === 'create_account') {


                                        return (

                                            assetOperation.kind === 'cashout' ?
                                                <CashoutListItem
                                                    key={assetOperation.id}
                                                    operation={assetOperation}
                                                    asset={asset[0]}
                                                    onClick={() => { goCashoutDetails(assetOperation) }}
                                                />

                                                :

                                                <PaymentListItem
                                                    key={assetOperation.id}
                                                    operation={assetOperation}
                                                    asset={asset[0]}
                                                    onClick={() => { goToPaymentDetails(assetOperation) }}

                                                />
                                        )
                                    }

                                    if (assetOperation.type === 'create_claimable_balance') {

                                        return (
                                            <CreateClaimableBalanceListItem
                                                key={assetOperation.id}
                                                operation={assetOperation}
                                                asset={asset[0]}
                                                onClick={() => assetOperation.isRecipient ? goToClaimableDetails(assetOperation) : goToPaymentDetails(assetOperation)}
                                            />
                                        )

                                    }

                                })

                        }

                        {/** This is a work around to deal with the last element of the list
                             * not fully displaying. We will need to update this in future versions
                             */}
                        <IonItem style={{ '--background': "var(--ion-background-color)" }} lines="none"></IonItem>

                        {/** */}
                 

                    <IonInfiniteScroll

                        onIonInfinite={loadMoreEvent}
                        threshold="15px"
                        disabled={isInfiniteDisabled}

                    >
                        <IonInfiniteScrollContent
                            style={{ backgroundColor: 'var(--ion-background-color)' }}
                            loadingSpinner="bubbles"
                            loadingText={t('operation.list.component.INFINITE-SCROLL-CONTENT-LOADING-TEXT') as string}
                        ></IonInfiniteScrollContent>
                    </IonInfiniteScroll>
                </div>
            </IonContent>


        </>
    )

}

export default OperationList